export default "__VITE_ASSET__88b52d83__"